import UserApi from '@api/UserApi';

export default {
  addAclsForNewUser({ commit, state }, newAcls) {
    commit('SET_NEW_USER_ACLS', newAcls);
  },
  clearUserAndRoles({ commit }, userId) {
    commit('CLEAR_USER_AND_ROLES', userId);
  },
  fetchUserById({ commit }, userId) {
    if (!userId) {
      throw new Error(
        'You need to provide a userId for me to fetch one using it'
      );
    } else {
      return new UserApi()
        .search({
          userId,
          requiredUserProfileOnly: true
        })
        .then(res => {
          commit('SET_USER', {
            userId: userId,
            user: res
          });
        })
        .catch(ex => {
          console.error('error encountered when fetching user', ex);
        });
    }
  }
};
